/**
 * Endpoints de operaciones y movimientos.
 */

import {
  GetOperacionesResponse,
  GetMovimientosResponse,
  type Operacion,
  type Movimiento,
} from '@/api/contracts/operaciones';
import { getDb } from '@/api/mock/db';

const MOCK_LATENCY_MS = 120;
function delay(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/** GET /api/operaciones */
export async function getOperaciones(): Promise<Operacion[]> {
  await delay(MOCK_LATENCY_MS);
  return GetOperacionesResponse.parse(getDb().operaciones);
}

/** GET /api/movimientos */
export async function getMovimientos(): Promise<Movimiento[]> {
  await delay(MOCK_LATENCY_MS);
  return GetMovimientosResponse.parse(getDb().movimientos);
}
